var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169 150L180.25 172.25L194 200H300V325H100V150H169ZM184.5 100H75C68.3696 100 62.0107 102.634 57.3223 107.322C52.6339 112.011 50 118.37 50 125V350C50 356.63 52.6339 362.989 57.3223 367.678C62.0107 372.366 68.3696 375 75 375H325C331.63 375 337.989 372.366 342.678 367.678C347.366 362.989 350 356.63 350 350V175C350 168.37 347.366 162.011 342.678 157.322C337.989 152.634 331.63 150 325 150H225L207 113.75C204.903 109.589 201.686 106.097 197.71 103.667C193.735 101.238 189.159 99.9676 184.5 100Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569 150L580.25 172.25L594 200H700V325H500V150H569ZM584.5 100H475C468.37 100 462.011 102.634 457.322 107.322C452.634 112.011 450 118.37 450 125V350C450 356.63 452.634 362.989 457.322 367.678C462.011 372.366 468.37 375 475 375H725C731.63 375 737.989 372.366 742.678 367.678C747.366 362.989 750 356.63 750 350V175C750 168.37 747.366 162.011 742.678 157.322C737.989 152.634 731.63 150 725 150H625L607 113.75C604.903 109.589 601.686 106.097 597.71 103.667C593.735 101.238 589.159 99.9676 584.5 100Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 475L180.25 497.25L194 525H300V650H100V475H169ZM184.5 425H75C68.3696 425 62.0107 427.634 57.3223 432.322C52.6339 437.011 50 443.37 50 450V675C50 681.63 52.6339 687.989 57.3223 692.678C62.0107 697.366 68.3696 700 75 700H325C331.63 700 337.989 697.366 342.678 692.678C347.366 687.989 350 681.63 350 675V500C350 493.37 347.366 487.011 342.678 482.322C337.989 477.634 331.63 475 325 475H225L207 438.75C204.903 434.589 201.686 431.097 197.71 428.667C193.735 426.238 189.159 424.968 184.5 425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569 475L580.25 497.25L594 525H700V650H500V475H569ZM584.5 425H475C468.37 425 462.011 427.634 457.322 432.322C452.634 437.011 450 443.37 450 450V675C450 681.63 452.634 687.989 457.322 692.678C462.011 697.366 468.37 700 475 700H725C731.63 700 737.989 697.366 742.678 692.678C747.366 687.989 750 681.63 750 675V500C750 493.37 747.366 487.011 742.678 482.322C737.989 477.634 731.63 475 725 475H625L607 438.75C604.903 434.589 601.686 431.097 597.71 428.667C593.735 426.238 589.159 424.968 584.5 425Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategories);
export default __webpack_public_path__ + "static/media/icon_categories.1f72502f9ac821e65001df11472a300d.svg";
export { ForwardRef as ReactComponent };